'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reduxForm = require('redux-form');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reactScroll = require('react-scroll');

var _components = require('../../../components');
var _OMTextArea = require('../OMTextArea/OMTextArea');var _OMTextArea2 = _interopRequireDefault(_OMTextArea);

var _constants = require('../../../constants');

var _OMTextFieldWithOptionsLang = require('./OMTextFieldWithOptionsLang.scss');var styles = _interopRequireWildcard(_OMTextFieldWithOptionsLang);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles`
var OMTextFieldWithOptionsLang = function (_Component) {_inherits(OMTextFieldWithOptionsLang, _Component);function OMTextFieldWithOptionsLang() {var _temp, _this, _ret;_classCallCheck(this, OMTextFieldWithOptionsLang);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      activeLang: _this.props.isForeign ? _constants.language.fallback : _constants.language.default }, _this.












    handleSwitchLang = function (key) {return _this.setState({ activeLang: key });}, _this.

    renderTextArea = function (fieldProps) {var _cx;var
      input = fieldProps.input,isHebrew = fieldProps.isHebrew,label = fieldProps.label,_fieldProps$meta = fieldProps.meta,touched = _fieldProps$meta.touched,error = _fieldProps$meta.error,active = _fieldProps$meta.active;

      return (
        _react2.default.createElement(_reactScroll.Element, { name: input.name, className: styles.formField },
          _react2.default.createElement(_OMTextArea2.default, _extends({
            className: (0, _classnames2.default)({ 'has-error': error && !active && touched, touched: touched }, (_cx = {}, _cx[styles.hebrew] = isHebrew, _cx), _this.props.className) },
          input, {
            maxLength: _this.props.maxLength || '',
            placeholder: label,
            isInput: _this.props.isInput })),

          touched &&
          error && _react2.default.createElement('span', { className: styles.required }, _this.props.translate('errorFieldMessages', 'required'))));


    }, _this.

    renderField = function (lang) {
      var isHebrew = lang === _constants.language.default;var _this$props =
      _this.props,placeholderInput = _this$props.placeholderInput,name = _this$props.name,translate = _this$props.translate;

      return (
        _react2.default.createElement(_reduxForm.Field, {
          key: lang + '_' + name,
          name: name + '.' + lang,
          component: _this.renderTextArea,
          label: placeholderInput ?
          placeholderInput('langs', 'placeholder', lang) :
          translate('langs', 'placeholder', lang),

          isHebrew: isHebrew }));


    }, _this.

    renderTab = function (lang) {return (
        _react2.default.createElement(_components.OMTab, {
            key: _this.props.name + '_' + lang,
            id: lang,
            title: _this.props.translate('langs', lang),
            isDisabled: _this.props.isOptionalLangsDisabled &&
            lang !== (_this.props.isForeign ? _constants.language.fallback : _constants.language.default) },

          _this.renderField(lang)));}, _temp), _possibleConstructorReturn(_this, _ret);}OMTextFieldWithOptionsLang.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {var isLocaleChanged = nextProps.locale !== this.props.locale;var isActiveLangChanged = nextState.activeLang !== this.state.activeLang;var isDisabledStateChanged = nextProps.isOptionalLangsDisabled !== this.props.isOptionalLangsDisabled;var isFields = nextProps.fields !== this.props.fields;var isNameStateChanged = nextProps.name !== this.props.name;return isLocaleChanged || isActiveLangChanged || isDisabledStateChanged || isFields || isNameStateChanged;};OMTextFieldWithOptionsLang.prototype.



  render = function render() {var _props =
    this.props,fields = _props.fields,maxLength = _props.maxLength,isForeign = _props.isForeign;var
    activeLang = this.state.activeLang;
    var supportedLanguages = (0, _get2.default)(_constants.language, '' + (isForeign ? 'supportedForeignLanguages' : 'supportedLanguages'), []);

    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.item, 'text-field-with-optional-langs') },
        _react2.default.createElement(_components.OMTabs, {
            defaultActiveTabKey: this.state.activeLang,
            onSelect: this.handleSwitchLang,
            className: (0, _classnames2.default)(this.props.classNameTabs, 'optional-langs-tabs') },

          supportedLanguages.map(this.renderTab)),

        maxLength &&
        _react2.default.createElement('div', { className: styles.maxLength },
          _react2.default.createElement('p', null,
            fields && fields[activeLang] ? fields[activeLang].length : 0, ' / ', maxLength))));





  };return OMTextFieldWithOptionsLang;}(_react.Component);


OMTextFieldWithOptionsLang.propTypes = {
  translate: _propTypes2.default.func,
  name: _propTypes2.default.string,
  placeholder: _propTypes2.default.object,
  isInput: _propTypes2.default.bool,
  isOptionalLangsDisabled: _propTypes2.default.bool,
  classNameTabs: _propTypes2.default.string,
  className: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  placeholderInput: _propTypes2.default.string,
  fields: _propTypes2.default.object,
  maxLength: _propTypes2.default.string,
  isForeign: _propTypes2.default.bool };exports.default =


OMTextFieldWithOptionsLang;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMTextFieldWithOptionsLang/OMTextFieldWithOptionsLang.js
// module id = 1223
// module chunks = 0